export type DerivativePriceRule = {
	type: string,
	value?: number,
};

export const calculateDerivativeSubmittedPrice = (
	anchorSubmittedPrice: number,
	rule?: DerivativePriceRule,
): number => {
	if (!rule || rule.type === 'SAME') {
		return Math.round(anchorSubmittedPrice);
	}

	const ruleValue = Number(rule.value ?? 0);

	if (rule.type === 'AMOUNT') {
		return Math.round(anchorSubmittedPrice + ruleValue);
	}

	if (rule.type === 'PERCENTAGE') {
		return Math.round(anchorSubmittedPrice * (1 + ruleValue / 100));
	}

	return Math.round(anchorSubmittedPrice);
};

export const shouldSynchronizeDerivativePrices = (
	previousPrices: (number | undefined)[],
	currentPrices: (number | undefined)[],
	anchorRoomIndex: number,
	suppressionEpochChanged = false,
): boolean => {
	if (suppressionEpochChanged || anchorRoomIndex < 0 || previousPrices[anchorRoomIndex] === currentPrices[anchorRoomIndex]) {
		return false;
	}

	return currentPrices.every((price, roomIndex) =>
		roomIndex === anchorRoomIndex || previousPrices[roomIndex] === price,
	);
};
